const CardTitle = ({children}) => {
    return (
        <div>
            <h6 className="mb-2 font-bold uppercase">{children}</h6>
        </div>
    );
};

export default CardTitle;